"use strict";

exports["null"] = null;

exports.nullable = function (a, r, f) {
  return a == null ? r : f(a);
};

exports.notNull = function (x) {
  return x;
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Nullable/foreign.js
// module id = 575
// module chunks = 0